// extracted by mini-css-extract-plugin
export default {"container":"BannerNavigation_container__sfDyZ"};